import { render, staticRenderFns } from "./auto-message-template-search-table.vue?vue&type=template&id=c48241a0&scoped=true&"
import script from "./auto-message-template-search-table.vue?vue&type=script&lang=js&"
export * from "./auto-message-template-search-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48241a0",
  null
  
)

export default component.exports